/**
 * NAVBAR
 */

const header = document.querySelector('.j-header')
const navbar = document.querySelector('.j-navbar')
const navbarContent = document.querySelector('.j-navbar__content')
const navbarPages = document.querySelectorAll('.j-navbar__page')
const navbarItems = document.querySelectorAll('.j-navbar__item')
const navbarSubItems = document.querySelectorAll('.j-navbar__subitem')
const navbarButtonToggle = document.querySelector('.j-navbar__toolbar-button')

// When the upper level (page) is closed, then we will close all the lower levels (items)

const closeNavLowerLevels = () => {
	navbarPages.forEach(function (navbarPage) {
		navbarPage.addEventListener('click', function () {
			if (!navbarPage.classList.contains('is-active')) {
				navbarItems.forEach(function (item) {
					item.classList.remove('is-active')
				})
				navbarSubItems.forEach(function (item) {
					item.classList.remove('is-active')
				})
			}
		})
	})
}

// On mobile viewport, clicking the hamburger menu icon, the <body> will be in position fixed to prevent scrolling

const setToggleMenuEvents = () => {
	navbarButtonToggle.addEventListener('click', function () {
		// Set/unset body fixed
		document.body.classList.toggle(
			'is-fixed',
			navbar.classList.contains('is-active'),
		)

		// Closing menu, close all sublevels
		if (!navbar.classList.contains('is-active')) {
			navbarPages.forEach(function (item) {
				item.classList.remove('is-active')
			})
			navbarItems.forEach(function (item) {
				item.classList.remove('is-active')
			})
			navbarSubItems.forEach(function (item) {
				item.classList.remove('is-active')
			})
		}
	})
}

// Close menu when the user clicks outside it

const closeMenuClickOutside = () => {
	document.addEventListener('click', (e) => {
		if (navbar.classList.contains('is-active')) {
			if (!navbarContent.contains(e.target)) {
				// click outside of 'j-navbar__content'
				// note: we cannot use 'j-navbar' because its ::after element occupies all the available space in viewport
				document.body.classList.remove('is-fixed')
				navbar.classList.remove('is-active')
			}
		}
	})
}

// On each page hover, we have to add 'is-active' on the main 'j-navbar' node. We need this to win the z-index war (see navbar.scss is-active z-index)

const addNavbarActiveOnHover = () => {
	navbarPages.forEach(function (pageToggle) {
		// add 'is-active' on hover
		pageToggle.addEventListener('mouseover', function () {
			navbar.classList.add('is-active')
		})
		// remove 'is-active' on mouseout
		pageToggle.addEventListener('mouseout', function () {
			navbar.classList.remove('is-active')
		})
	})
}

if (navbar && header) {
	closeNavLowerLevels()
	setToggleMenuEvents()
	closeMenuClickOutside()

	// from desktop up, just to be sure that in small screens – without mobile simulator active – this function will not be triggered
	if (window.matchMedia('(min-width: 1024px)').matches) {
		addNavbarActiveOnHover()
	}
}

// Back to top button
//Get the button:
backToTop = document.querySelector('.c-back-to-top');

// When the user scrolls down 500px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
    backToTop.classList.remove('is-hidden');
  } else {
	backToTop.classList.add('is-hidden');
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction(e) {
  e.preventDefault()
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
} 

if(backToTop) {
	backToTop.addEventListener('click', topFunction)
}